<template>
  <BreadCrumb :PageTitle="pageTitle" :IntermediaryItems="breadcrumbItems" />
  <AddOrEditMerchantOrder @pageUpdate="updateBreadCrumbTitle" />
</template>

<script lang="ts">
import { defineComponent } from "vue";

import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import AddOrEditMerchantOrder from "../../components/Wholesale/AddOrEditMerchantOrder.vue";

export default defineComponent({
  name: "AddOrEditMerchantOrderPage",
  components: {
    BreadCrumb,
    AddOrEditMerchantOrder,
  },
  data() {
    return {
      breadcrumbItems: [
        {
          name: 'Wholesale Customers List',
          to: '/wholesale/customers'
        }
      ],
      pageTitle: this.$route.name == "EditMerchantOrder" ? 'Edit Merchant Order' : 'Add Merchant Order'
    }
  },
  methods: {
    updateBreadCrumbTitle(page) {
      this.pageTitle = page == "EditMerchantOrder" ? 'Edit Merchant Order' : 'Add Merchant Order';
    }
  }
});
</script>